

import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Select } from 'antd';
import { GestionPaieService } from '../../Services/GestionPaieService';
import moment from 'moment';
const {Option} = Select
const DuplicataModal = ({ visible, onClose }) => {
  const [form] = Form.useForm();

  const gestionPaieService = new GestionPaieService();

  const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [duplicata, setDuplicata] = useState([]);
    const [periods, setPeriods] = useState([]);

    useEffect(() => {
      if (visible ) {
        fetchData();
      }
    }, [visible]);
    const fetchData = async () => {
      
        try {
          const response = await gestionPaieService.getDuplicata();
          setDuplicata(response);
       
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
        }
      };

      const fetchPeriods = async (matricule) => {
        try {
          const response = await gestionPaieService.getPeriod(matricule);
          setPeriods(response);
        } catch (error) {
          console.error('Erreur lors de la récupération des périodes :', error);
        }
      };
      const handleEmployeeChange = (value) => {
        setSelectedEmployee(value);
        fetchPeriods(value);
      };
            
     
      const handlePrint = () => {
        form.validateFields()
          .then((values) => {
            const { matricule, fin } = values;
            gestionPaieService.printBulletinIndiv(matricule, fin);
            form.resetFields();
            setSelectedEmployee(null);
            setPeriods([]);
            onClose();
          })
          .catch((info) => {
            console.log('Validation échouée:', info);
          });
      };
      
      const handleClose = ()=>{
        form.resetFields();
        setSelectedEmployee(null);
        setPeriods([]);
        onClose();
      }

  return (
    <Modal
      title="Edition Duplicata Bulletin"
      open = {visible}
      onCancel={onClose}
      maskClosable={false}
      footer={[
        <Button key="cancel" className='buttonClose' onClick={handleClose}>Annuler</Button>,
        <Button key="print" className='buttonImprim' onClick={handlePrint}>Imprimer</Button>
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="matricule" label="Salarié" rules={[{ required: true, message: 'Veuillez sélectionner un salarié' }]}>
          <Select placeholder="Sélectionnez un salarié" onChange={handleEmployeeChange}>
          {duplicata.map(({ matricule, prenoms, nom }) => (
            <Option key={matricule} value={matricule}>
              {`${matricule} - ${prenoms} ${nom}`}
            </Option>
          ))}
          </Select>
        </Form.Item>
        <Form.Item name="fin" label="Période" rules={[{ required: true, message: 'Veuillez sélectionner une période' }]}>
  <Select
    placeholder="Sélectionnez une période"
    disabled={!selectedEmployee}
  >
    {periods.map(({fin}) => (
      <Option key={fin} value={fin}>
        { moment(fin).format('DD/MM/YYYY')}
      </Option>
    ))}
  </Select>
</Form.Item>

      </Form>
    </Modal>
  );
};

export default DuplicataModal;
